import { getStoreDataByPhysicalStoreId } from '@/data/utils/commonIntegrationUtils';
import { useCurrentPhysicalStoreId } from 'presentation/events/hooks/useCurrentPhysicalStoreId';
import { useMemo } from 'react';

export type TrackingStoreLocation = {
	city: string | undefined;
	state: string | undefined;
	zipCode: string | undefined;
};

export const useTrackingStoreLocation = (): TrackingStoreLocation | null => {
	const { physicalStoreId } = useCurrentPhysicalStoreId();

	return useMemo(() => {
		if (!physicalStoreId) return null;

		const storeData = getStoreDataByPhysicalStoreId(physicalStoreId);

		return {
			city: storeData?.city,
			state: storeData?.stLocName,
			zipCode: storeData?.zipcode,
		};
	}, [physicalStoreId]);
};
